export default "__VITE_ASSET__DBd0kl74__"